(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bmh-amanecer-ux"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('bmh-amanecer')) {
  customElements.define('bmh-amanecer', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.abort = new AbortController();
      const signal = this.abort.signal;
      const gallery = this.querySelector('.bmhux-images');
      const slides = [...gallery.querySelectorAll('.bmhux-photo')];
      const thumbs = [...this.querySelectorAll('[data-gallery-index]')];
      const prev = this.querySelector('[data-gallery-prev]');
      const next = this.querySelector('[data-gallery-next]');
      const count = this.querySelector('[data-gallery-count]');
      const reduce = matchMedia('(prefers-reduced-motion: reduce)');
      let current = 0;
      const show = index => gallery.scrollTo({ left: Math.max(0, Math.min(slides.length - 1, index)) * gallery.clientWidth, behavior: reduce.matches ? 'instant' : 'smooth' });
      const update = () => {
        current = Math.round(gallery.scrollLeft / Math.max(1, gallery.clientWidth));
        count.textContent = `${current + 1} / ${slides.length}`;
        thumbs.forEach((button, index) => button.setAttribute('aria-current', String(index === current)));
        prev.disabled = current === 0;
        next.disabled = current === slides.length - 1;
      };
      this.querySelector('.bmhux-thumbs').hidden = false;
      prev.hidden = next.hidden = slides.length < 2;
      prev.addEventListener('click', () => show(current - 1), { signal });
      next.addEventListener('click', () => show(current + 1), { signal });
      thumbs.forEach((button, index) => button.addEventListener('click', () => show(index), { signal }));
      gallery.addEventListener('scroll', update, { passive: true, signal });
      gallery.addEventListener('keydown', event => {
        if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') { event.preventDefault(); show(current + (event.key === 'ArrowRight' ? 1 : -1)); }
      }, { signal });
      this.querySelector('[data-variant-select]')?.addEventListener('change', event => { const url = new URL(location.href); url.searchParams.set('variant', event.target.value); location.assign(url.toString()); }, { signal });
      const sticky = this.querySelector('.bmhux-sticky');
      const form = this.querySelector('.bmhux-form');
      if ('IntersectionObserver' in window && form) {
        this.observer = new IntersectionObserver(entries => { const entry = entries[0]; sticky.hidden = entry.isIntersecting || entry.boundingClientRect.bottom > 0; }, { threshold: 0 });
        this.observer.observe(form);
      }
      update();
    }
    disconnectedCallback() { this.abort?.abort(); this.observer?.disconnect(); this.ready = false; }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
